import { Box, CardMedia, Icon, InputAdornment, Skeleton, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import React, { useEffect, useState } from 'react'
import defaultAvatar from 'assets/images/default_avatar.png'
import {
  getStaffWithNoData,
  sendPersonalityTestInvite,
} from 'services/api/modules/recruitment/job-application'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import { useDebouncedEffect } from 'services/hooks/useDebouncedEffect'
import AdxEmptyState from 'components/reusable/emptyState/AdxEmptyState'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxButton from 'components/custom/AdxButton'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const InvitePersonalityTestModal = ({ open, handleCloseModal, handleOpenModal }) => {
  // modal styles and logic
  const handleOpen = () => {
    handleOpenModal()
  }
  const handleClose = () => {
    handleCloseModal()
  }
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '850px',
    width: '100%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '4.5px',
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '24px',
    outline: 'none',
  }

  // search
  const [searchItem, setSearchItem] = useState('')
  const [search, setSearch] = useState('')
  const handleSearch = (value) => {
    setSearchItem(value)
  }
  const handleClearSearch = () => {
    setSearchItem('')
  }
  // set delay for search api
  useDebouncedEffect(
    () => {
      if (searchItem.length > 0) {
        setSearch(`&search=${searchItem}`)
      } else {
        setSearch('')
      }
    },
    [searchItem],
    700
  )

  // For initial run when component is mounted for the staff count box
  const [initialStaffCount, setInitialStaffCount] = useState(0)

  // snackbar logic
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false)
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false)

  // API call
  const queryClient = useQueryClient()
  const { isLoading: staffIsLoading, data: staffData } = useQuery(
    ['getStaffWithNoData', search],
    async () => {
      const { data } = await getStaffWithNoData(search)
      return data
    }
  )

  // useEffect(() => {
  //   if (staffData?.pending_count > 0) {
  //     setInitialStaffCount(staffData?.pending_count)
  //   }
  // }, [staffData?.pending_count])

  const { mutate: sendInviteMutate } = useMutation(
    (payload) => sendPersonalityTestInvite(payload),
    {
      onSuccess: async (response) => {
        setTimeout(() => {
          queryClient.invalidateQueries(['getStaffWithNoData', search])
          setEmailLoading(null)
          setAllEmailLoading(false)
          setSuccessSnackbarOpen(true)
        }, 3000)
        console.log(response)
      },
      onError: (error) => {
        setErrorSnackbarOpen(true)
        console.log(error)
      },
    }
  )

  // map email to array to send all
  const emailArray = staffData?.staff?.map((i) => i.email)
  const [emailLoading, setEmailLoading] = useState(null)
  const [allEmailLoading, setAllEmailLoading] = useState(false)

  return (
    <>
      {staffData?.pending_count > 0 && (
        <Box
          sx={{
            backgroundColor: 'light-yellow-01.main',
            marginBottom: '12px',
            padding: '12px 16px',
            borderLeft: 1,
            borderLeftWidth: '3px',
            borderLeftColor: 'yellow-01.main',
            borderRadius: '2px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <Icon sx={{ color: 'warning.main' }}>error</Icon>
          <Typography variant="body1" sx={{ width: '100%' }}>
            {`${initialStaffCount} staff did not complete the work personality test.`}
          </Typography>
          <Typography
            onClick={handleOpen}
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
              color: 'yellow-02.main',
              fontWeight: 500,
            }}
          >
            View
          </Typography>
          {open && (
            <>
              <SnackbarRecruitment
                autoHideDuration={3000}
                status="error"
                TransitionComponent="slide"
                message="An error has occured. Please try again"
                open={errorSnackbarOpen}
                handleClose={() => setErrorSnackbarOpen(false)}
              />
              <SnackbarRecruitment
                autoHideDuration={3000}
                status="success"
                TransitionComponent="slide"
                message="Staff successfully invited!"
                open={successSnackbarOpen}
                handleClose={() => setSuccessSnackbarOpen(false)}
              />
            </>
          )}
        </Box>
      )}
      <AdxFormModal
        open={open}
        handleClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        title="Invite to take test"
        enableFooter
        actionText="Invite all"
        isLoading={allEmailLoading}
        handleAction={() => {
          setAllEmailLoading(true)
          sendInviteMutate({ emails: emailArray })
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'light-yellow-01.main',
              p: 2,
              borderRadius: '4.5px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
              width: '100%',
            }}
          >
            <Icon sx={{ color: 'warning.main' }}>error</Icon>
            <Typography variant="body1" sx={{ width: '100%' }}>
              {`${initialStaffCount} staff did not complete the work personality test. Send them invitation via email
                to take the test.`}
            </Typography>
          </Box>
          <AdxInput
            placeholder="Search name"
            value={searchItem}
            onChange={(e) => handleSearch(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <Icon>search</Icon>
              </InputAdornment>
            }
            endAdornment={
              searchItem ? (
                <InputAdornment position="end">
                  <Icon onClick={handleClearSearch} sx={{ color: 'error.main', cursor: 'pointer' }}>
                    close
                  </Icon>
                </InputAdornment>
              ) : null
            }
          />

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 16px',
                backgroundColor: 'gray-background.main',
                alignSelf: 'stretch',
                gap: '16px',
              }}
            >
              <Typography sx={{ width: '50%' }}>Staff</Typography>
              <Typography sx={{ width: '50%' }}>Email</Typography>
            </Box>
            {staffIsLoading ? (
              <StaffLoadingState />
            ) : searchItem.length > 0 && staffData?.staff.length === 0 ? (
              <Box sx={{ width: '100%', height: 200 }} display="flex">
                <AdxEmptyStateV2
                  icon={<Icon sx={{ fontSize: 40 }}>question_mark</Icon>}
                  message="Staff does not exist"
                />
              </Box>
            ) : (
              <Box sx={{ width: '100%', height: '100%' }}>
                {staffData?.staff?.map((item, key) => (
                  <Box
                    key={key}
                    display="flex"
                    alignItems="center"
                    gap="16px"
                    padding="12px 16px"
                    sx={{ width: '100%' }}
                  >
                    <Box sx={{ position: 'relative' }}>
                      <CardMedia
                        component="img"
                        sx={{
                          height: 45,
                          width: 45,
                          objectFit: 'cover',
                          borderRadius: '100%',
                        }}
                        src={item?.profile_image_url ?? defaultAvatar}
                      />
                      {item?.has_invited === 1 && (
                        <Box
                          sx={{
                            backgroundColor: 'white.main',
                            position: 'absolute',
                            right: -8,
                            bottom: 0,
                            zIndex: 2,
                            height: 18,
                            width: 18,
                            borderRadius: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Icon
                            sx={{
                              position: 'absolute',
                              color: 'info.main',
                              zIndex: 3,
                            }}
                          >
                            telegram
                          </Icon>
                        </Box>
                      )}
                    </Box>
                    <Box sx={{ width: '50%' }}>
                      <Typography
                        variant="subtitle1"
                        color="dark-text.main"
                        sx={{
                          overflow: 'auto',
                          textOverflow: 'ellipsis',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {item?.name}
                      </Typography>
                    </Box>
                    <Box sx={{ width: '40%' }}>
                      <Typography
                        variant="body2"
                        color="light-gray-text.main"
                        sx={{
                          overflow: 'auto',
                          textOverflow: 'ellipsis',
                          wordBreak: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {item?.email}
                      </Typography>
                    </Box>
                    {item?.has_invited === 0 ? (
                      <AdxButton
                        variant={'contained'}
                        isLoading={emailLoading === item?.email ? true : false}
                        sx={{
                          width: '100%',
                          maxWidth: '106px',
                          padding: '12px 14px',
                          boxShadow: 'none',
                          height: '35px',
                        }}
                        onClick={() => {
                          setEmailLoading(item?.email)
                          sendInviteMutate({ emails: [item?.email] })
                        }}
                      >
                        Send invite
                      </AdxButton>
                    ) : (
                      <AdxButton
                        variant={'outlined'}
                        isLoading={emailLoading === item?.email ? true : false}
                        sx={{
                          border: 'none',
                          textDecoration: 'underline',
                          width: '100%',
                          maxWidth: '106px',
                          padding: '12px 14px',
                          boxShadow: 'none',
                          height: '35px',
                        }}
                        onClick={() => {
                          setEmailLoading(item?.email)
                          sendInviteMutate({ emails: [item?.email] })
                        }}
                      >
                        Reinvite
                      </AdxButton>
                    )}
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </AdxFormModal>
    </>
  )
}

export default InvitePersonalityTestModal

const StaffLoadingState = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Box display="flex" alignItems="center" gap="16px" padding="12px 16px" sx={{ width: '100%' }}>
        <Skeleton variant="circular" width={45} height={45} />
        <Box sx={{ width: '40%' }}>
          <Skeleton variant="rounded" width={'60%'} />
        </Box>
        <Box sx={{ width: '40%' }}>
          <Skeleton variant="rounded" width={'60%'} />
        </Box>
      </Box>
      <Box display="flex" alignItems="center" gap="16px" padding="12px 16px" sx={{ width: '100%' }}>
        <Skeleton variant="circular" width={45} height={45} />
        <Box sx={{ width: '40%' }}>
          <Skeleton variant="rounded" width={'60%'} />
        </Box>
        <Box sx={{ width: '40%' }}>
          <Skeleton variant="rounded" width={'60%'} />
        </Box>
      </Box>
    </Box>
  )
}
